import clone from 'lodash.clonedeep';

export const SHOP_FEED_SAVED_SEARCH_LIMIT = 15;
export const SHOP_FEED_SEARCH_CONCURRENCY = 5;
export const SHOP_FEED_RESULTS_PER_SEARCH = 100;

export async function mapWithConcurrency(items, concurrency, fn) {
  if (!items.length) {
    return [];
  }

  const results = new Array(items.length);
  let index = 0;

  async function worker() {
    while (index < items.length) {
      const currentIndex = index;
      index += 1;
      results[currentIndex] = await fn(items[currentIndex], currentIndex);
    }
  }

  const workers = Math.min(concurrency, items.length);
  await Promise.all(Array.from({ length: workers }, worker));

  return results;
}

function dedupeListingsByItemId(listings) {
  const itemIds = listings.map(({ itemId }) => itemId);

  return listings.filter(({ itemId }, listingIndex) => !itemIds.includes(itemId, listingIndex + 1));
}

export async function loadShopListingsFeed({
  savedFilters,
  searchService,
  defaultFilters,
  savedSearchLimit = SHOP_FEED_SAVED_SEARCH_LIMIT,
  resultsPerSearch = SHOP_FEED_RESULTS_PER_SEARCH,
  concurrency = SHOP_FEED_SEARCH_CONCURRENCY,
}) {
  const filtersToSearch = savedFilters.slice(0, savedSearchLimit);
  const listings = [];

  const shopFilterResults = await mapWithConcurrency(
    filtersToSearch,
    concurrency,
    (savedFilter) => searchService.search({
      index: 'listings',
      query: savedFilter.query,
      page: 1,
      limit: resultsPerSearch,
      sort: 'createdDate',
      direction: 'desc',
      filters: {
        ...clone(defaultFilters),
        ...savedFilter.filters,
        endDate: 'now',
      },
    }),
  );

  shopFilterResults.forEach((shopFilterResult) => {
    if (shopFilterResult !== null) {
      listings.push(...shopFilterResult.hits);
    }
  });

  listings.sort((a, b) => b.createdDate - a.createdDate);

  return {
    listings: dedupeListingsByItemId(listings),
    totalSavedFilters: savedFilters.length,
    searchedSavedFilters: filtersToSearch.length,
    savedSearchLimit,
  };
}

export function getShopFeedCapNotice({
  totalSavedFilters,
  searchedSavedFilters,
  savedSearchLimit,
}) {
  if (totalSavedFilters <= savedSearchLimit) {
    return null;
  }

  return `Showing results from ${searchedSavedFilters} of your ${totalSavedFilters} saved searches.`;
}
